"use client";
// Déclencheur global de la modale « Une idée ? » (retours de la phase de lancement).
// Les trois points d'entrée — le bouton flottant du catalogue, le bloc sous la FAQ
// de l'accueil et le lien du pied de page — appellent openIdeaPrompt(source) ; la
// modale, montée une seule fois au layout racine, écoute et s'ouvre. Même patron
// pub/sub que authPrompt.ts.
//
// Montée à la RACINE et non dans le hero : le hero est forcé en thème sombre
// (data-theme="dark"), une modale rendue dedans hériterait de ce thème même
// quand le site est en clair.

/** D'où vient l'ouverture — repris tel quel par la mesure d'audience. */
export type IdeaSource = "fab" | "faq" | "footer";

type Listener = (source: IdeaSource) => void;
const listeners = new Set<Listener>();

export function openIdeaPrompt(source: IdeaSource) {
  for (const l of listeners) l(source);
}

export function onIdeaPrompt(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
